import { render, staticRenderFns } from "./ResultsSwot.vue?vue&type=template&id=6d26bf42&"
import script from "./ResultsSwot.vue?vue&type=script&lang=js&"
export * from "./ResultsSwot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports